// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3AqGc","fadeIn":"styles_fadeIn__3HFsH","title":"styles_title__1lW3T","gif":"styles_gif__2J3s6","text":"styles_text__3Ud81","button":"styles_button__29rZh"};